import { initUrl } from '@/config/axios_config'

// <<<<<<<<<<<<<<<<<<<<<表单创建接口>>>>>>>>>>>>>>>>>>>>>>>>



// 根据地区代码，获取其下的行政区域树
export const getAreaTreePageByAreaCode = data => initUrl(`/area/getAreaTreePageByAreaCode`, data, 'GET')


// 新增
// export const questionnaireAdd = data => initUrl(`/questionnaire/add`, data, 'POST')
export const questionnaireAddOrUpdate = data => initUrl(`/scale/addOrUpdate`, data, 'POST')
/*
新接口不需要更新，后端直接通过data里的id判断
*/
// 更新
// export const questionnaireEdit = data => initUrl(`/questionnaire/edit`, data, 'POST')

// 分享表单
export const questionnaireShare = data => initUrl(`/scale/updateState`, data, 'GET')


// 删除
// export const questionnaireDel = data => initUrl(`/questionnaire/delete`, data, 'GET')
export const questionnaireDel = data => initUrl(`/scaleDept/deleteScale`, data, 'GET')

// 查询详情
// export const questionnaireDetail = data => initUrl(`/questionnaire/detail`, data, 'GET')
export const questionnaireDetail = data => initUrl(`/scale/getById`, data, 'GET')


// 修改限制条件
export const updateLimit = data => initUrl(`/questionnaire/updateLimit`, data, 'POST')

// 查询列表
// export const questionnairePage = data => initUrl(`/questionnaire/page`, data, 'GET')
export const questionnairePage = data => initUrl(`/scaleDept/pageName`, data, 'POST')
// export const questionnairePage = data => initUrl(`/scaleDept/getPage`, data, 'POST')

// 导出表单提交记录EXCEL
export const questionnaireOutPutExcel = data => initUrl(`/questionnaire/outPutExcel`, data, 'GET', { responseType: 'blob'})

// 修改表单状态（0未发布 1已发布 2停止发布）
// export const setUnpublish = data => initUrl(`/questionnaire/setUnpublish`, data, 'GET')
export const setUnpublish = data => initUrl(`/scale/updateState`, data, 'GET')

// 下载表单相关附件文件夹
export const downloadFolderByQuestionnaireId = data => initUrl(`/questionnaire/downloadFolderByQuestionnaireId`, data, 'GET', { responseType: 'blob'})


// 复制表单
// export const copyQuestionnaire = data => initUrl(`/questionnaire/copyQuestionnaire`, data, 'GET')
export const copyQuestionnaire = data => initUrl(`/scale/copyScale`, data, 'POST')

// 修改二维码样式
export const setCodeStyle = data => initUrl(`/questionnaire/setCodeStyle`, data, 'GET')


// 获取表单统计分析
export const questionnaireAnalysis = data => initUrl(`/questionnaire/questionnaireAnalysis`, data, 'GET')

// 表单管理 查看数据 list 分页 /questionnaireReport/page
export const questionnaiList = data => initUrl("/questionnaireReport/page", data, 'GET')

// 表单管理 查看数据 批量删除记录
export const questionnaiDelete = data => initUrl("/questionnaireReport/batchDelete", data, 'POST')


export const getWxUserByRelevance = data => initUrl("/faceRecognition/getWxUserByRelevance", data, 'GET')



export const questionnaireReportDetail = data => initUrl("/questionnaireReport/detail", data, 'GET')   //查看详情


// 设置为模板
export const updateByIsFormwork = data => initUrl("/questionnaire/updateByIsFormwork", data, 'GET')

/**
 * 上传量表信息
 * @param {*} data 
 * @returns 
 */
// export const updateScaleNote = data => initUrl("/scale/addOrUpdateByNote", data, 'POST')
export const updateScaleNote = data => initUrl("/scaleDept/addOrUpdateScaleAndToMe", data, 'POST')
/**
 *  查询量表信息
 * @param {*} data 
 * @returns 
 */
export const getScaleNote = data => initUrl("/scale/getNoteByScaleId", data, 'GET')

// 问卷模板
export const getFormWorkPageList = data => initUrl("/questionnaire/getFormWorkPage", data, 'GET')

// 问卷绑定 自己对应的截图
export const questionnaireAddPicture = data => initUrl("/questionnaire/addPicture", data, 'GET')

//优化加载数据问题

export const questionnaireAnalysisOptimize = data => initUrl("/questionnaire/questionnaireAnalysisOptimize", data, 'POST')

// 通过问卷ID 获取问题答题的各个ID   
export const getQuestionIdList = data => initUrl("/questionnaire/getQuestionIdList", data, 'GET')



// WEBPACK FOOTER //
// ./src/api/business/questionnaireManage.js